import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../../../api";
import urls from "../../../../../urls";
import type { EnergyAvailabilityDataType } from "../EnergyDataAvailability.types";

export function useEnergyDataAvailability({
  siteId,
  firstDate,
  lastDate
}: {
  siteId: number;
  firstDate: string;
  lastDate: string;
}) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["energyDataAvailability", { siteId, firstDate, lastDate }],
    queryFn: () => fetchEnergyDataAvailability(siteId, firstDate, lastDate),
    retry: false
  });

  return {
    data,
    isLoading,
    error
  };
}

async function fetchEnergyDataAvailability(
  siteId: number,
  firstDate: string,
  lastDate: string
) {
  const response = await apiWithoutCamelization.get<EnergyAvailabilityDataType>(
    urls.apiWithoutCamelization.energyDataAvailability(
      siteId,
      firstDate,
      lastDate
    )
  );
  return response.data;
}
